export const PLATFORM = {
  MOVE: 'MDG_MOVE',
  GUARDIAN: 'MDG_GUARDIAN',
}
